export enum MemoPopUpActionEnum {
  DEFER = 'DEFER',
  GIVE_UP = 'GIVE_UP',
}
